/**
 * UI多言語化の純ロジック(React 非依存)。
 *
 * i18n.tsx(Provider / hook)から分離しているのは、ルートの vitest からも
 * このモジュールを読むため。ルート実行では web の react が解決できないので、
 * テスト対象になる関数を JSX を含むモジュールに置かない。
 * 方式の説明は i18n.tsx 冒頭を参照。
 */
import { ZH } from "./i18n.zh";

export type UiLang = "ja" | "zh";

export const LANG_STORAGE_KEY = "recipe-sop:ui-lang";

/** 原文(日本語)をキーに辞書を引き、{name} プレースホルダを置換する */
export function translate(
  lang: UiLang,
  ja: string,
  params?: Record<string, string | number>,
): string {
  let s = lang === "zh" ? (ZH[ja] ?? ja) : ja;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}

/** Date.toLocaleString 用。言語と揃える */
export function localeOf(lang: UiLang): string {
  return lang === "zh" ? "zh-TW" : "ja-JP";
}

/**
 * 品目名の表示。中国語表示のときは翻訳済みの料理名(nameZh)を出す。
 *
 * nameZh はワーカーが組版のたびに analysis.translations.zh から書く
 * (マニュアル本文の見出しと同じ訳)。未翻訳の品目は日本語名のまま出す。
 */
export function dishTitle(
  dish: { name: string; nameZh?: string | null } | null | undefined,
  lang: UiLang,
): string | null {
  if (!dish) return null;
  return lang === "zh" && dish.nameZh ? dish.nameZh : dish.name;
}
